<div class="modal-header">
  <h5 class="modal-title">Pay Invoice</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
  <div *ngIf="isGatewayLoading" class="text-center py-4">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="text-muted mt-2 mb-0">Loading secure payment form...</p>
  </div>

  <div *ngIf="!isGatewayLoading && !invoiceEmittedData" class="alert alert-warning mb-0">
    Invoice details are not available for payment.
  </div>

  <div
    *ngIf="
      !isGatewayLoading &&
      invoiceEmittedData &&
      paymentFlowType === paymentFlowTypeEnum.BRAINTREE
    "
    class="custom-card mt-3 p-3"
  >
    <p class="text-muted mb-3">
      Complete the secure payment step to continue.
    </p>
    <app-braintree-checkout
      [context]="paymentContext"
      [amount]="invoiceEmittedData?.data?.total_amount || 0"
      [threeDSecure]="is3dsEnabled"
      [reloadToken]="braintreeReloadToken"
      (paymentNonce)="onGatewayBraintreeNonce($event)"
      (paymentError)="onGatewayBraintreeError($event)"
    ></app-braintree-checkout>
  </div>

  <div
    *ngIf="
      !isGatewayLoading &&
      invoiceEmittedData &&
      paymentFlowType === paymentFlowTypeEnum.STRIPE_REDIRECT
    "
    class="custom-card mt-3 p-4 text-center"
  >
    <p class="text-muted mb-3">
      You will be redirected to Stripe to complete this payment securely.
    </p>
    <button class="btn btn-primary" (click)="redirectToStripeCheckout()">
      Continue To Stripe
    </button>
  </div>

  <ng-container
    *ngIf="
      !isGatewayLoading &&
      invoiceEmittedData &&
      paymentFlowType !== paymentFlowTypeEnum.BRAINTREE &&
      paymentFlowType !== paymentFlowTypeEnum.STRIPE_REDIRECT
    "
  >
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a
          class="nav-link"
          [class.active]="activeTab === 'cvv'"
          (click)="switchTab('cvv')"
          href="javascript:void(0)"
        >
          Existing Card
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          [class.active]="activeTab === 'creditCard'"
          (click)="switchTab('creditCard')"
          href="javascript:void(0)"
        >
          New Card
        </a>
      </li>
    </ul>

    <div class="custom-card mt-3">
      <div *ngIf="activeTab === 'cvv'">
        <app-adhoc-cvv-payment (paymentSuccess)="handlePaymentSuccess()"></app-adhoc-cvv-payment>
      </div>
      <div *ngIf="activeTab === 'creditCard'">
        <app-adhoc-credit-card-payment (paymentSuccess)="handlePaymentSuccess()"></app-adhoc-credit-card-payment>
      </div>
    </div>
  </ng-container>
</div>
